import { api } from './client'

export type StoryType = 'photo' | 'video' | 'text'
export type Privacy = 'all' | 'contacts' | 'selected'

export interface Story {
  id: string
  owner_id: string
  media_file_id: string
  text: string
  bg_color: string
  type: StoryType
  privacy: Privacy
  views_count: number
  expires_at: string
  created_at: string
}

export const storiesApi = {
  create: (data: {
    media_file_id?: string
    text?: string
    bg_color?: string
    type: StoryType
    privacy?: Privacy
  }): Promise<Story> =>
    api.post('/v1/stories/', data),

  getFeed: (userIds: string[]): Promise<{ stories: Story[] }> =>
    api.get(`/v1/stories/feed?ids=${userIds.join(',')}&limit=200`),

  getUserStories: (userId: string): Promise<{ stories: Story[] }> =>
    api.get(`/v1/stories/user/${userId}`),

  get: (id: string): Promise<{ story: Story; reactions: { emoji: string; count: number; my_react: boolean }[] }> =>
    api.get(`/v1/stories/${id}`),

  delete: (id: string): Promise<void> =>
    api.delete(`/v1/stories/${id}`),

  markViewed: (id: string): Promise<void> =>
    api.post(`/v1/stories/${id}/view`, {}),

  react: (id: string, emoji: string): Promise<void> =>
    api.put(`/v1/stories/${id}/react`, { emoji }),

  unreact: (id: string): Promise<void> =>
    api.delete(`/v1/stories/${id}/react`),

  getViewers: (id: string): Promise<{ viewers: Array<{ story_id: string; viewer_id: string; viewed_at: string }> }> =>
    api.get(`/v1/stories/${id}/viewers?limit=100`),

  createHighlight: (name: string, coverStoryId?: string): Promise<{ id: string; name: string; cover_story_id?: string }> =>
    api.post('/v1/stories/highlights/', { name, cover_story_id: coverStoryId }),

  listHighlights: (userId: string): Promise<{ highlights: Array<{ id: string; name: string; cover_story_id?: string }> }> =>
    api.get(`/v1/stories/highlights/user/${userId}`),

  deleteHighlight: (highlightId: string): Promise<void> =>
    api.delete(`/v1/stories/highlights/${highlightId}`),

  getHighlightStories: (highlightId: string): Promise<{ stories: Story[] }> =>
    api.get(`/v1/stories/highlights/${highlightId}/stories`),

  addToHighlight: (highlightId: string, storyId: string): Promise<void> =>
    api.post(`/v1/stories/highlights/${highlightId}/stories/${storyId}`, {}),

  removeFromHighlight: (highlightId: string, storyId: string): Promise<void> =>
    api.delete(`/v1/stories/highlights/${highlightId}/stories/${storyId}`),

  updateHighlight: (highlightId: string, name: string, coverStoryId?: string): Promise<{ id: string; name: string; cover_story_id?: string }> =>
    api.put(`/v1/stories/highlights/${highlightId}`, { name, cover_story_id: coverStoryId }),
}
